import React from "react";
import { AiArtwork } from "../data/aiArtworks";
import { ArtworkLightboxShell } from "./ArtworkLightboxShell";
import { AiLightboxContent } from "./AiArtworkCards";

export function AiLightbox({
  work,
  onClose,
  onNavigate,
  showNavigation = true,
  exploreGalleryHref,
}: {
  work: AiArtwork;
  onClose: () => void;
  onNavigate?: (direction: -1 | 1) => void;
  showNavigation?: boolean;
  exploreGalleryHref?: string;
}) {
  return (
    <ArtworkLightboxShell
      ariaLabel={work.id}
      imageUrl={work.imageUrl}
      imageAlt={work.id}
      onClose={onClose}
      onNavigate={onNavigate}
      showNavigation={showNavigation}
    >
      <AiLightboxContent work={work} exploreGalleryHref={exploreGalleryHref} />
    </ArtworkLightboxShell>
  );
}
